<template>
    <div>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-button class="button_back" @click="goBack">
                    <ion-icon name="arrow-back-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-buttons slot="end" v-if="$route.name == 'auth_billing_name'">
                <ion-button @click="skip">
                    <span>Skip</span>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>

        <div class="main_wrapper ion-padding">
            <div class="container">
                <div class="auth-header">
                    <div class="auth-heading">
                        <h1>{{ pageText[userRole].pageTitle }}</h1>
                        <span> {{ pageText[userRole].formText }}</span>
                    </div>
                    <div class="brand-icon">
                        <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
                    </div>
                </div>

                <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                    :ref="el => formsData.userForm.ref = el" :label-position="'top'" @submit.prevent="save('userForm')">

                    <!-- PHARMACY -->
                    <template v-if="userRole == 'pharmacy'">
                        <template v-if="$route.name != 'auth_billing_name'">
                            <el-form-item :label="pageText[userRole].placeholders.name" prop="name" :required='true'>
                                <el-input v-model="formsData.userForm.name.value" autocomplete="off"
                                    :placeholder="pageText[userRole].placeholders.name" :maxlength="75"
                                    @keyup="formsData.userForm.name.value = $event.target.value"></el-input>
                            </el-form-item>
                        </template>
                        <template v-else>
                            <el-form-item :prop="'businessName'" :required='true'>
                                <el-input v-model="formsData.userForm.businessName.value" autocomplete="off"
                                    :placeholder="pageText[userRole].placeholders.businessName" :maxlength="40"
                                    @keyup="formsData.userForm.businessName.value = $event.target.value"
                                    :disabled="formsData.userForm.businessName.disabled"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-checkbox v-model="formsData.userForm.businessName.disabled"
                                    @change="onNameCheckboxChange">Same as Business Name</el-checkbox>
                            </el-form-item>
                        </template>
                    </template>
                    <!-- LOCUM -->
                    <template v-else>
                        <el-form-item class="no-scroll" :label="pageText[userRole].placeholders.firstName"
                            prop="firstName" :required='true'>
                            <el-input v-model="formsData.userForm.firstName.value" autocomplete="off"
                                :placeholder="pageText[userRole].placeholders.firstName" :maxlength="20"
                                @keyup="formsData.userForm.firstName.value = $event.target.value"></el-input>
                        </el-form-item>
                        <el-form-item class="no-scroll" :label="pageText[userRole].placeholders.lastName"
                            prop="lastName" :required='true'>
                            <el-input v-model="formsData.userForm.lastName.value" autocomplete="off"
                                :placeholder="pageText[userRole].placeholders.lastName" :maxlength="20"
                                @keyup="formsData.userForm.lastName.value = $event.target.value"></el-input>
                        </el-form-item>
                    </template>
                    <el-form-item class="button_submit mb0">
                        <el-button class="submit" type="blue" @click="save('userForm')"
                            :disabled="!formsData.userForm.isFormValid">
                            Continue
                        </el-button>
                    </el-form-item>
                </el-form>
                <div class="background-circles">
                    <div class="circle circle-2"></div>
                    <div class="circle circle-1"></div>
                    <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import {
    onMounted,
    inject,
} from 'vue';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useStore
} from 'vuex'

import {
    useRouter,
    useRoute
} from 'vue-router'
import formHooks from '@/hooks/form/form'
import formValidate from '@/hooks/form/validate/validate'
import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon,
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const $route = useRoute()
        const setPageClassGlobal = inject(['setPageClassGlobal']);

        const userData = $store.getters.GET_USER_DATA;
        const userRole = userData.role;

        const pageText = {
            locum: {
                pageTitle: 'Your Name',
                formText: 'Please provide legal full name on your AHPRA registration',
                placeholders: {
                    firstName: 'Please enter your Given Name',
                    lastName: 'Please enter your Family Name'
                }
            },
            pharmacy: {
                pageTitle: $route.name == 'auth_billing_name' ? 'Billing Name' : 'Business Name',
                formText: 'What is the name of your pharmacy?',
                placeholders: {
                    name: 'Pharmacy Name',
                    businessName: 'Billing Name'
                },

            }
        }

        const formsDataArray = {
            userForm: {}
        };

        if (userRole == 'locum') {
            const dataArray = {
                firstName: {
                    value: userData.firstName || '',
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'firstName', callback, setFormValidation);
                        },
                    }]
                },

                lastName: {
                    value: userData.lastName || '',
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'lastName', callback, setFormValidation);
                        },
                    }]
                },
            }

            Object.assign(formsDataArray.userForm, dataArray);
        }

        // const goBack = () => {
        //     $store.dispatch('AUTH_LOGOUT')
        // };

        const goBack = () => {
            $router.push({
                name: 'profile',
            })
        };

        const goNext = () => {
            if (userRole == 'locum') {
                $router.push({
                    name: 'onboard_birthday',
                })
            }
        };


        const save = (formName) => {
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    (async () => {
                        try {
                            await $store.dispatch('SAVE_USER_DATA', getFormValues(formName));
                            goNext()
                        } catch (error) {
                            console.log('error submit!!');
                        }
                    })();
                } else {
                    setFormValidation(formName, false, false);
                    console.log('error submit!!');
                    return false;
                }
            });
        }

        onMounted(() => {
            setPageClassGlobal('global_onboard_internal_page');
            setFormRefs();
            formsRefs.userForm.value.$el[0].focus();
            checkFormValidation('userForm', true);
            checkFormChanged("userForm", false);
        });

        const {
            checkFormValidation,
            setFormValidation,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
            checkFormChanged,
        } = formHooks(formsDataArray);

        return {
            formsData,
            goBack,
            save,
            userRole,
            pageText,
        }
    },
}
</script>